import React, { useEffect, useContext } from 'react'
import AuthContext from './context/auth/authContext'
import queryString from 'query-string';
import Header from './components/Header';
import Footer from './components/Footer';
import StepsList from './components/StepsList';
import Spinner from './components/Spinner';
import Privacy from './components/modals/Privacy'
import { hotjar } from 'react-hotjar';
// import ReactGA from 'react-ga';
// import ReactPixel from 'react-facebook-pixel';
// ReactPixel.init('628337984806049');

function App() {
  const authContext = useContext(AuthContext);
  const { getPageInfo, getToken, getLead, leadLoading, modal, toggleModal, setDocusignEvent } = authContext;
  useEffect(() => {
    const getJWT = async () => {
      await getToken();
      let url = window.location.search;
      let token = queryString.parse(url).token;
      let oldToken = localStorage.getItem('lead_token');
      let docusignEvent = queryString.parse(url).event;
      // console.log(docusignEvent)
      hotjar.initialize(2452029, 6);

      await getPageInfo();
      const $token = token ? token : localStorage.getItem('lead_token');
      if (token || oldToken) {
        getLead($token);
      }

      if (docusignEvent) {
        setDocusignEvent(docusignEvent, $token);
        await getLead($token);

      }
      // ReactGA.initialize('G-0C85MFRMHM');
      // ReactGA.pageview(window.location.pathname + window.location.search);
    }
    getJWT();
    //eslint-disable-next-line
    // ReactPixel.pageView();
  }, [])
  return (
    <div id="app">
      <Header />

      {leadLoading ? <Spinner /> : <StepsList />}


      <Footer />
      {modal ?
        <Privacy modal={modal} toggleModal={toggleModal} />
        : ''}
    </div>
  );
}

export default App;
